import templateUrl from 'emun.order/ticket-prompt.htm'
import TicketPromptController from 'emun.order/ticket-prompt.controller'

import open from "webmodals/open";
let TicketPrompt = (options) => {
	let modalInstance = open({
		size: options.size || 'md',
		templateUrl: options.templateUrl || templateUrl,
		controller: TicketPromptController,
		bindToController: true,
		controllerAs: '$ctrl',
		resolve: {
			options: () => options
		}
	});

	return modalInstance.result;
}

export default TicketPrompt;